import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M25.192 23.778 17.414 16l7.778-7.778a1 1 0 0 0-1.414-1.414L16 14.586 8.222 6.808a1 1 0 1 0-1.414 1.414L14.586 16l-7.778 7.778a1 1 0 1 0 1.414 1.414L16 17.414l7.778 7.778a1 1 0 1 0 1.414-1.414" }, null, -1)
  ]))]))
}
export default { render: render }